import React from 'react';
import ModernStatsCard from '../ModernStatsCard';
import millify from 'millify';

export interface PlatformOverview {
  gmv: number;
  cashbackPaid: number;
  roas: number;
  totalCampaigns: number;
  activeCampaigns: number;
  totalBrands: number;
  totalCreators: number;
  totalDeposited: number;
  deployedBudget: number;
  budgetActivationRate: number;
  pendingSubmissions: number;
  aiApprovalRate: number;
  mrr: number;
  arr: number;
}

interface PlatformKpiGridProps {
  data: PlatformOverview | null;
  loading: boolean;
}

const PlatformKpiGrid: React.FC<PlatformKpiGridProps> = ({ data, loading }) => {
  const kpis = [
    {
      label: 'Total GMV',
      value: data ? `€${millify(data.gmv)}` : '—',
    },
    {
      label: 'Cashback Paid',
      value: data ? `€${millify(data.cashbackPaid)}` : '—',
    },
    {
      label: 'ROAS',
      value: data ? `${data.roas}x` : '—',
    },
    {
      label: 'Active Campaigns',
      value: data ? `${data.activeCampaigns} / ${data.totalCampaigns}` : '—',
    },
    {
      label: 'Total Brands',
      value: data?.totalBrands ?? 0,
    },
    {
      label: 'Total Creators',
      value: data?.totalCreators ?? 0,
    },
    {
      label: 'Pending Reviews',
      value: data?.pendingSubmissions ?? 0,
    },
    {
      label: 'AI Approval Rate',
      value: data ? `${data.aiApprovalRate}%` : '—',
    },
    {
      label: 'MRR',
      value: data ? `€${millify(data.mrr)}` : '—',
    },
    {
      label: 'ARR',
      value: data ? `€${millify(data.arr)}` : '—',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
      {kpis.map((kpi) => (
        <ModernStatsCard
          key={kpi.label}
          label={kpi.label}
          value={kpi.value}
          loading={loading}
        />
      ))}
    </div>
  );
};

export default PlatformKpiGrid;
